<template>
  <div class="login-container">
    <div class="login-card">
      <div class="left-card">
        <img class="login-graphics" src="/img/login/login-icon.png" alt="logo" />
        <img class="login-bg" src="/img/login/login-bg.png" alt="logo" />
        <div class="welcome-text">
          <p>HI，您好！</p>
          <p>欢迎使用智慧管家云服务平台</p>
        </div>
        <div class="copyright">©2020-2025 <span v-html="companyName"></span></div>
      </div>
      <div class="right-card">
        <!-- <div class="login-title" v-if="logo">
          <img :src="logo" alt="logo">
        </div> -->
        <div class="login-title">
          <img src="/img/login/login-title.png" alt="logo" />
        </div>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item class="login-item-username" label="登录账号" prop="username">
            <el-input v-model="loginForm.username" :placeholder="$t('login.usernamePlaceholder')"></el-input>
          </el-form-item>
          <el-form-item class="login-item-password" label="登陆密码" prop="passwd">
            <el-input v-model="loginForm.passwd" type="password" :placeholder="$t('login.passwordPlaceholder')"></el-input>
          </el-form-item>
          <el-form-item class="login-item-validateCode" label="验证码" prop="validateCode">
            <div class="captcha-container">
              <el-input v-model="loginForm.validateCode" :placeholder="$t('login.captchaPlaceholder')"></el-input>
              <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" alt="验证码">
            </div>
          </el-form-item>
          <el-form-item class="login-item-button">
            <el-button type="primary" @click="submitForm('loginForm')" :loading="loading">{{ $t('login.login')
            }}</el-button>
          </el-form-item>
        </el-form>
        <!-- Add a white line and copyright info below the form -->
        <div class="divider"></div>
      </div>
    </div>
    <select-login-user ref="selectLoginUserRef" @select="handleSelect"></select-login-user>
  </div>
</template>

<script>
import { login, getCaptcha, _loadStaffPrivileges } from '@/api/user/loginApi';
import { _loadCommunityInfo } from '@/api/community/communityApi';
import {listSystemInfo} from '@/api/system/systemInfoManageApi'
import selectLoginUser from '@/components/user/selectLoginUser.vue';


export default {
  name: 'Login',
  data() {
    return {
      logo: '',
      companyName:'',
      loginForm: {
        username: '',
        passwd: '',
        validateCode: ''
      },
      captchaUrl: '',
      loading: false,
      rules: {
        username: [
          { required: true, message: this.$t('login.usernamePlaceholder'), trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: this.$t('login.passwordPlaceholder'), trigger: 'blur' }
        ],
        validateCode: [
          { required: true, message: this.$t('login.captchaPlaceholder'), trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    localStorage.clear();
    this.getSystemInfo()
    setTimeout(() => {
      this.refreshCaptcha();
    }, 1000);
    
  },
  components: {
    selectLoginUser
  },
  methods: {
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.logo = data[0].logoUrl
      this.companyName = data[0].companyName
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const { data } = await login(this.loginForm).catch(error => {
              this.$message.error(error);
              this.refreshCaptcha();
              return { data: [] };  
            });
            if (!data || data.length == 0) {
              return;
            }

            if (data && data.length > 1) {
              this.$refs.selectLoginUserRef.openDialog(data);
              return;
            }
            this.handleSelect(data[0]);
          } catch (error) {
            console.error('登录失败：', error);
            this.refreshCaptcha();
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
    async handleSelect(_userData) {
      localStorage.setItem('token', _userData.token);
      let _user = {
        userId: _userData.userId,
        name: _userData.name,
        tel: _userData.tel
      }
      localStorage.setItem('user', JSON.stringify(_user));
      await _loadStaffPrivileges();
      await _loadCommunityInfo();
      this.$router.push('/');
    },
    async refreshCaptcha() {
      try {
        const res = await getCaptcha();
        console.log(res);
        this.captchaUrl = res;
      } catch (error) {
        console.error('获取验证码失败：', error);
        this.$message.error(this.$t('login.getCaptchaFailed'));
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #68a5f4;
  position: relative;
  overflow: hidden;
}

.login-card {
  width: 1230px;
  height: 650px;
  background: #007eeb;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  display: flex;
}

.login-card .left-card {
  width: 50%;
  color: #fff;
  position: relative;
}

.login-card .right-card {
  width: 50%;
  background: #fff;
  border: 10px solid #86b7f6;
}

.left-card .login-graphics {
  position: absolute;
  width: 140px;
  height: auto;
  top: 80px;
  left: 54px;
}

.left-card .login-bg {
  position: absolute;
  width: 376px;
  height: auto;
  top: 55px;
  right: 0;
}

.left-card .welcome-text {
  position: absolute;
  top: 340px;
  left: 54px;
  font-size: 30px;
  font-weight: 600;
  text-align: left;
  line-height: 58px;
  letter-spacing: 2px;
}

.left-card .welcome-text p {
  margin: 0;
}

.left-card .copyright {
  position: absolute;
  left: 54px;
  bottom: 82px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.25);
}

.right-card .login-title {
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #269afe;
}

.login-title img {
  height: 50px;
  width: auto;
}

.right-card .el-form {
  padding: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.el-form-item {
  margin-bottom: 38px;
}

.right-card :deep(.el-form-item__label) {
  color: #333;
  font-size: 16px;
  line-height: 28px;
}

.right-card .el-form-item.is-required :deep(.el-form-item__label:before) {
  display: none;
}

.right-card :deep(.el-input__inner) {
  height: 48px;
  line-height: 48px;
  border-width: 0 0 1px;
  border-radius: 0;
  padding: 0;
}

.login-item-username {
  width: 100%;
}

.login-item-password {
  width: 53%;
}

.login-item-validateCode {
  width: 42%;
}

.login-item-button {
  width: 100%;
  text-align: right;
}

.captcha-container {
  width: 100%;
  position: relative;
}

.captcha-img {
  position: absolute;
  right: 0;
  bottom: 4px;
  height: 40px;
  cursor: pointer;
  border-radius: 5px;
}

.captcha-container .el-input :deep(.el-input__inner) {
  padding-right: 120px;
}

.login-item-button .el-button {
  margin-top: 50px;
  width: 200px;
  height: 60px;
  background: #4bad41;
  border-color: #4bad41;
  font-size: 16px;
  letter-spacing: 1px;
  box-shadow: 0 2px 6px 0 rgba(75, 173, 65, 0.8);
}

.login-item-button .el-button:hover {
  opacity: 0.8;
  color: #fff;
}
</style>